import {
  RulesOfUseContent,
  RulesOfUseContentList,
  RulesOfUseItem,
  RulesOfUseItemTitle,
  RulesOfUseTitle,
  Wrapper,
} from "./style";

export const RulesOfUse = () => {
  return (
    <Wrapper>
      <RulesOfUseTitle>FLYASHGABAT.COM</RulesOfUseTitle>

      <RulesOfUseContent>
        <strong>Website Terms of Use</strong>
      </RulesOfUseContent>

      <RulesOfUseContent>
        Individual Enterprise "Jahankeshde Hyzmat"
      </RulesOfUseContent>

      <RulesOfUseContent>
        <strong>Last updated:</strong> 20 August 2026
      </RulesOfUseContent>

      {/* 1. GENERAL PROVISIONS */}

      <RulesOfUseItem>
        <RulesOfUseItemTitle>GENERAL PROVISIONS</RulesOfUseItemTitle>

        <RulesOfUseContent>
          These Terms of Use govern access to the website{" "}
          <a
            href="https://flyashgabat.com"
            target="_blank"
            rel="noreferrer"
          >
            https://flyashgabat.com
          </a>{" "}
          and the use of its features and functionality.
        </RulesOfUseContent>

        <RulesOfUseContent>
          The Website is owned and administered by Individual Enterprise
          "Jahankeshde Hyzmat" (hereinafter referred to as the "Website
          Administration", "FlyAshgabat", "we", "us" or "our").
        </RulesOfUseContent>

        <RulesOfUseContent>
          Any person who visits the Website or uses its features and
          functionality is hereinafter referred to as the "User".
        </RulesOfUseContent>

        <RulesOfUseContent>
          By using the Website, the User confirms that they:
        </RulesOfUseContent>

        <RulesOfUseContentList>
          <li>have read these Terms;</li>
          <li>understand the contents of these Terms;</li>
          <li>accept these Terms and agree to comply with them;</li>
          <li>
            have the legal capacity and authority required to use the Website
            and place orders.
          </li>
        </RulesOfUseContentList>

        <RulesOfUseContent>
          If the User does not agree to these Terms, they must stop using the
          Website.
        </RulesOfUseContent>

        <RulesOfUseContent>
          Additional terms may apply to individual FlyAshgabat services,
          including the Booking and Service Purchase Rules, Refund Policy,
          Privacy Policy, and the rules of airlines, hotels, carriers, payment
          organisations and other service providers.
        </RulesOfUseContent>

        <RulesOfUseContent>
          If these Terms conflict with special rules applicable to a particular
          service or booking, the relevant special rules shall prevail unless
          otherwise required by law.
        </RulesOfUseContent>
      </RulesOfUseItem>

      {/* 2. PURPOSE OF THE WEBSITE */}

      <RulesOfUseItem>
        <RulesOfUseItemTitle>PURPOSE OF THE WEBSITE</RulesOfUseItemTitle>

        <RulesOfUseContent>
          The FlyAshgabat Website enables Users to:
        </RulesOfUseContent>

        <RulesOfUseContentList>
          <li>search for and compare available travel services;</li>
          <li>
            obtain information about schedules, routes, fares and conditions of
            carriage;
          </li>
          <li>submit requests and make bookings;</li>
          <li>
            purchase airline tickets and other services available through the
            Website;
          </li>
          <li>contact customer support;</li>
          <li>use other features and functionality of the Website.</li>
        </RulesOfUseContentList>

        <RulesOfUseContent>
          Unless expressly stated otherwise, FlyAshgabat acts as an agent or
          intermediary between the User and the relevant service provider,
          including an airline, hotel, carrier, booking system or other travel
          service provider.
        </RulesOfUseContent>

        <RulesOfUseContent>
          The terms of a particular service may be governed not only by
          FlyAshgabat documents but also by the rules of the relevant provider.
          By placing an order, the User agrees to comply with the applicable
          rules of the selected provider.
        </RulesOfUseContent>
      </RulesOfUseItem>

      {/* 3. INFORMATION ABOUT PRICES AND SERVICES */}

      <RulesOfUseItem>
        <RulesOfUseItemTitle>
          INFORMATION ABOUT PRICES AND SERVICES
        </RulesOfUseItemTitle>

        <RulesOfUseContent>
          Information about schedules, seat availability, fares, baggage,
          ancillary services and other conditions is supplied by airlines,
          booking systems and other providers.
        </RulesOfUseContent>

        <RulesOfUseContent>
          FlyAshgabat takes reasonable steps to provide current information.
          However, the price and availability of a service may change before
          the booking is confirmed, payment is received and the relevant ticket
          or other document is issued.
        </RulesOfUseContent>

        <RulesOfUseContent>
          A price displayed in the search results is not considered finally
          confirmed until the booking has been completed. The final order
          price, including applicable fees and ancillary services, is displayed
          to the User before payment or communicated by customer support.
        </RulesOfUseContent>

        <RulesOfUseContent>
          A booking is considered confirmed only after the User receives the
          relevant confirmation, itinerary receipt, electronic ticket, voucher
          or other document.
        </RulesOfUseContent>

        <RulesOfUseContent>
          FlyAshgabat may cancel an unconfirmed order or offer the User an
          alternative if, before the ticket is issued or the service is
          confirmed:
        </RulesOfUseContent>

        <RulesOfUseContentList>
          <li>the fare is no longer available;</li>
          <li>the provider changes the price or applicable conditions;</li>
          <li>the booking time limit expires;</li>
          <li>a technical error occurs;</li>
          <li>the provider declines to confirm the service.</li>
        </RulesOfUseContentList>

        <RulesOfUseContent>
          In such cases, the refund of any amount paid is governed by the
          applicable booking and refund rules.
        </RulesOfUseContent>
      </RulesOfUseItem>

      {/* 4. USER RESPONSIBILITIES */}

      <RulesOfUseItem>
        <RulesOfUseItemTitle>USER RESPONSIBILITIES</RulesOfUseItemTitle>

        <RulesOfUseContent>
          The User must provide complete, current and accurate information
          required to search for, book and arrange services.
        </RulesOfUseContent>

        <RulesOfUseContent>
          When booking an airline ticket, the User must independently verify
          the accuracy of:
        </RulesOfUseContent>

        <RulesOfUseContentList>
          <li>the passenger's first and last names;</li>
          <li>the date of birth;</li>
          <li>the sex;</li>
          <li>the nationality;</li>
          <li>the passport details;</li>
          <li>the itinerary;</li>
          <li>the travel dates and times;</li>
          <li>the contact details;</li>
          <li>the selected fare;</li>
          <li>the baggage allowance;</li>
          <li>the ancillary services.</li>
        </RulesOfUseContentList>

        <RulesOfUseContent>
          The passenger's first and last names must be entered in Latin
          characters exactly as shown in the document that will be presented
          during the journey.
        </RulesOfUseContent>

        <RulesOfUseContent>
          The User is responsible for the consequences of providing incorrect,
          incomplete or outdated information. Correcting information after a
          ticket has been issued may be impossible or may require an additional
          payment under the provider's rules.
        </RulesOfUseContent>

        <RulesOfUseContent>
          The User is responsible for ensuring that they possess all required:
        </RulesOfUseContent>

        <RulesOfUseContentList>
          <li>passports and other identity documents;</li>
          <li>visas and entry or transit permits;</li>
          <li>medical documents and insurance policies;</li>
          <li>consents required for minors to travel;</li>
          <li>
            documents required by the airline or by immigration, border,
            customs or other authorities.
          </li>
        </RulesOfUseContentList>

        <RulesOfUseContent>
          Before purchasing a service, the User must independently review the
          fare rules, exchange and refund conditions, baggage allowance,
          check-in requirements and other conditions of the selected service.
        </RulesOfUseContent>

        <RulesOfUseContent>
          The User must not:
        </RulesOfUseContent>

        <RulesOfUseContentList>
          <li>use the Website for unlawful or fraudulent purposes;</li>
          <li>provide false information;</li>
          <li>
            attempt to gain unauthorised access to the Website, its servers or
            information systems;
          </li>
          <li>interfere with the normal operation of the Website;</li>
          <li>
            use automated systems to collect information in bulk without
            FlyAshgabat's written permission;
          </li>
          <li>distribute malware;</li>
          <li>
            infringe the rights or legitimate interests of FlyAshgabat, other
            Users or third parties.
          </li>
        </RulesOfUseContentList>
      </RulesOfUseItem>

      {/* 5. USE OF WEBSITE MATERIALS */}

      <RulesOfUseItem>
        <RulesOfUseItemTitle>USE OF WEBSITE MATERIALS</RulesOfUseItemTitle>

        <RulesOfUseContent>
          The Website design, texts, graphics, logos, software code, databases
          and other materials available on the Website are the intellectual
          property of FlyAshgabat or the relevant rights holders.
        </RulesOfUseContent>

        <RulesOfUseContent>
          Website materials may be used solely for personal, non-commercial
          purposes, provided that all copyright and other proprietary notices
          are preserved.
        </RulesOfUseContent>

        <RulesOfUseContent>
          The copying, modification, publication, distribution, sale or other
          commercial use of Website materials without FlyAshgabat's prior
          written consent is prohibited unless expressly permitted by these
          Terms or by law.
        </RulesOfUseContent>

        <RulesOfUseContent>
          If FlyAshgabat materials that are authorised for copying are
          published on another online resource, an active hyperlink must be
          provided:
        </RulesOfUseContent>

        <RulesOfUseContentList>
          <li>
            to the homepage at{" "}
            <a
              href="https://flyashgabat.com"
              target="_blank"
              rel="noreferrer"
            >
              https://flyashgabat.com
            </a>
            ; or
          </li>
          <li>
            to the page from which the relevant material was obtained.
          </li>
        </RulesOfUseContentList>

        <RulesOfUseContent>
          The link must be accessible and must not be blocked from search-engine
          indexing by means of nofollow, noindex or any similar method.
        </RulesOfUseContent>

        <RulesOfUseContent>
          If Website materials are used unlawfully, FlyAshgabat may require the
          infringement to cease and the relevant materials to be removed, and
          may contact the website owner, hosting provider, search engine or
          competent authorities to protect its rights.
        </RulesOfUseContent>
      </RulesOfUseItem>

      {/* 6. THIRD-PARTY WEBSITES AND SERVICES */}

      <RulesOfUseItem>
        <RulesOfUseItemTitle>
          THIRD-PARTY WEBSITES AND SERVICES
        </RulesOfUseItemTitle>

        <RulesOfUseContent>
          The Website may contain links to third-party websites and services,
          including those of airlines, hotels, carriers, payment systems and
          other providers.
        </RulesOfUseContent>

        <RulesOfUseContent>
          Such websites and services operate independently of FlyAshgabat and
          may have their own terms of use and personal-data processing
          practices.
        </RulesOfUseContent>

        <RulesOfUseContent>
          FlyAshgabat does not control the content, availability, security or
          operation of third-party websites and is not responsible for the
          actions of their owners, except where such responsibility is
          expressly imposed by law.
        </RulesOfUseContent>

        <RulesOfUseContent>
          When visiting a third-party website, the User must independently
          review the terms and policies that apply to it.
        </RulesOfUseContent>
      </RulesOfUseItem>

      {/* 7. PERSONAL DATA */}

      <RulesOfUseItem>
        <RulesOfUseItemTitle>PERSONAL DATA</RulesOfUseItemTitle>

        <RulesOfUseContent>
          When the Website is used, FlyAshgabat may collect and process
          information necessary for:
        </RulesOfUseContent>

        <RulesOfUseContentList>
          <li>making and servicing bookings;</li>
          <li>issuing airline tickets and other travel documents;</li>
          <li>processing or confirming payment;</li>
          <li>communicating with the User;</li>
          <li>providing customer support;</li>
          <li>complying with legal requirements;</li>
          <li>
            maintaining Website security and preventing fraud.
          </li>
        </RulesOfUseContentList>

        <RulesOfUseContent>
          Such information may include a person's first name, last name, date
          of birth, nationality, sex, passport details, contact information,
          travel information, order details and other information required to
          provide the selected service.
        </RulesOfUseContent>

        <RulesOfUseContent>
          To fulfil an order, information may be shared with airlines, booking
          systems, hotels, carriers, payment organisations and other providers
          involved in delivering the service selected by the User.
        </RulesOfUseContent>

        <RulesOfUseContent>
          Personal data is processed and protected in accordance with the laws
          of Turkmenistan and the FlyAshgabat Privacy Policy.
        </RulesOfUseContent>

        <RulesOfUseContent>
          Further information about the data collected, the purposes and
          periods of processing, disclosure to third parties and the User's
          rights is provided in the Privacy Policy.
        </RulesOfUseContent>
      </RulesOfUseItem>

      {/* 8. WEBSITE AVAILABILITY AND SECURITY */}

      <RulesOfUseItem>
        <RulesOfUseItemTitle>
          WEBSITE AVAILABILITY AND SECURITY
        </RulesOfUseItemTitle>

        <RulesOfUseContent>
          FlyAshgabat takes reasonable technical and organisational measures to
          support the stable and secure operation of the Website.
        </RulesOfUseContent>

        <RulesOfUseContent>
          The Website Administration does not guarantee uninterrupted or
          error-free operation of the Website. Access to the Website or
          particular functions may be temporarily restricted due to:
        </RulesOfUseContent>

        <RulesOfUseContentList>
          <li>maintenance;</li>
          <li>software updates;</li>
          <li>equipment or communications failures;</li>
          <li>actions of third-party providers;</li>
          <li>circumstances beyond FlyAshgabat's control.</li>
        </RulesOfUseContentList>

        <RulesOfUseContent>
          FlyAshgabat may modify, update, temporarily suspend or discontinue
          individual Website functions, provided this does not violate its
          obligations in respect of confirmed orders or applicable legal
          requirements.
        </RulesOfUseContent>
      </RulesOfUseItem>

      {/* 9. LIMITATION OF LIABILITY */}

      <RulesOfUseItem>
        <RulesOfUseItemTitle>LIMITATION OF LIABILITY</RulesOfUseItemTitle>

        <RulesOfUseContent>
          To the extent permitted by law, FlyAshgabat is not liable for
          indirect losses, loss of profit or loss of data arising solely from
          the use of, or inability to use, the Website.
        </RulesOfUseContent>

        <RulesOfUseContent>
          FlyAshgabat is not responsible for the acts or decisions of airlines,
          airports, hotels, carriers, immigration, border or customs
          authorities, or other public authorities, including:
        </RulesOfUseContent>

        <RulesOfUseContentList>
          <li>a flight change or cancellation;</li>
          <li>a delay in carriage;</li>
          <li>a schedule change;</li>
          <li>a refusal of carriage;</li>
          <li>changes to baggage rules;</li>
          <li>a visa refusal;</li>
          <li>a refusal of entry or transit;</li>
          <li>loss of or damage to baggage;</li>
          <li>changes by a provider to the conditions of service.</li>
        </RulesOfUseContentList>

        <RulesOfUseContent>
          FlyAshgabat will nevertheless provide the User with reasonable
          assistance within the scope of its authority and the relevant
          provider's rules.
        </RulesOfUseContent>

        <RulesOfUseContent>
          FlyAshgabat is not responsible for consequences arising from:
        </RulesOfUseContent>

        <RulesOfUseContentList>
          <li>incorrect or incomplete information provided by the User;</li>
          <li>the User's failure to comply with fare or provider rules;</li>
          <li>the User's failure to possess the required documents;</li>
          <li>the User's late arrival for check-in or boarding;</li>
          <li>the actions of third parties;</li>
          <li>force majeure events.</li>
        </RulesOfUseContentList>

        <RulesOfUseContent>
          Nothing in these Terms limits the User's rights or FlyAshgabat's
          liability where such a limitation is prohibited by applicable law.
        </RulesOfUseContent>
      </RulesOfUseItem>

      {/* 10. AMENDMENTS TO THESE TERMS */}

      <RulesOfUseItem>
        <RulesOfUseItemTitle>
          AMENDMENTS TO THESE TERMS
        </RulesOfUseItemTitle>

        <RulesOfUseContent>
          FlyAshgabat may amend or supplement these Terms from time to time,
          including in response to changes in Website functionality, service
          procedures or legal requirements.
        </RulesOfUseContent>

        <RulesOfUseContent>
          An updated version of these Terms takes effect when it is published
          on the Website unless a different effective date is stated in that
          version.
        </RulesOfUseContent>

        <RulesOfUseContent>
          Amendments do not apply to previously confirmed orders to the extent
          that doing so would adversely affect the User or conflict with
          applicable law.
        </RulesOfUseContent>

        <RulesOfUseContent>
          Continued use of the Website after an updated version is published
          confirms that the User has reviewed the amended Terms.
        </RulesOfUseContent>
      </RulesOfUseItem>

      {/* 11. FINAL PROVISIONS */}

      <RulesOfUseItem>
        <RulesOfUseItemTitle>FINAL PROVISIONS</RulesOfUseItemTitle>

        <RulesOfUseContent>
          These Terms are governed by the laws of Turkmenistan.
        </RulesOfUseContent>

        <RulesOfUseContent>
          The parties will seek to resolve any dispute or disagreement through
          negotiation and consideration of a written claim.
        </RulesOfUseContent>

        <RulesOfUseContent>
          If a dispute cannot be resolved, it shall be dealt with in accordance
          with applicable law.
        </RulesOfUseContent>

        <RulesOfUseContent>
          If any provision of these Terms is found to be invalid or
          unenforceable, the validity and enforceability of the remaining
          provisions will not be affected.
        </RulesOfUseContent>

        <RulesOfUseContent>
          These Terms do not exclude or restrict any mandatory consumer rights
          provided by law.
        </RulesOfUseContent>
      </RulesOfUseItem>

      {/* 12. CONTACT INFORMATION */}

      <RulesOfUseItem>
        <RulesOfUseItemTitle>CONTACT INFORMATION</RulesOfUseItemTitle>

        <RulesOfUseContent>
          For questions relating to these Terms, the operation of the Website
          or the use of FlyAshgabat intellectual property, the User may contact
          us at:
        </RulesOfUseContent>

        <RulesOfUseContent>
          <strong>
            Individual Enterprise "Jahankeshde Hyzmat"
          </strong>
        </RulesOfUseContent>

        <RulesOfUseContent>
          <strong>Website:</strong>{" "}
          <a
            href="https://flyashgabat.com"
            target="_blank"
            rel="noreferrer"
          >
            https://flyashgabat.com
          </a>
        </RulesOfUseContent>

        <RulesOfUseContent>
          <strong>Email:</strong>{" "}
          <a href="mailto:info@flyashgabat.com">
            info@flyashgabat.com
          </a>
        </RulesOfUseContent>
      </RulesOfUseItem>
    </Wrapper>
  );
};

export default RulesOfUse;